import request from '@/utils/request'

// 用户端查询栏目集合
export function menuList(params) {
  return request({
    url: '/ims/ChannelBind/user/list',
    method: 'get',
    params
  })
}

export function menuList2(channelId) {
  return request({
    url: `/ims/ChannelBind/user/${channelId}`,
    method: 'get'
  })
}

// 用户端查询内容列表
export function contentList(params) {
  return request({
    url: '/ims/Content/user/list',
    method: 'get',
    params
  })
}

// 用户端查询单页栏目的内容
export function contentSingleDetail(channelId) {
  return request({
    url: `/ims/Content/user/single/${channelId}`,
    method: 'get'
  })
}

// 用户端查询按子栏目分组的内容列表
export function sonGroupList(params) {
  return request({
    url: `/ims/Content/user/sonGroupList/${params.channelId}`,
    method: 'get',
    params
  })
}

// 用户端查询内容详情
export function contentDetail(params) {
  return request({
    url: `/ims/Content/user/${params.channelId}/${params.id}`,
    method: 'get'
  })
}

// 用户端查询专栏栏目集合
export function specialGroupList(specialChannelId) {
  return request({
    url: `/ims/SpecialChannelBind/user/info/${specialChannelId}`,
    method: 'get',
  })
}

// 用户端查询轮播图集合
export function bannerList(params) {
  return request({
    url: '/ims/PictureBind/user/list',
    method: 'get',
    params
  })
}

// 用户端查询友情链接集合
export function linkList(params) {
  return request({
    url: '/ims/FriendshipLinkBind/user/list',
    method: 'get',
    params
  })
}

// 水印
export function waterMark() {
  return request({
    url: '/ims/WatermarkBind/user/info',
    method: 'get'
  })
}


export function memberRoles() {
  return request({
    url: '/ims/Uapi/switchMemberList',
    method: 'GET'
  })
}

export function login(data) {
  return request({
    url: '/auth/token',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'DELETE'
  })
}

export function checkTenantAndModule() {
  return request({
    url: '/ims/Uapi/checkTenantAndModule/member',
    method: 'GET'
  })
}

/* 发送短信 */
export function smsCode(mobile, params) {
  return request({
    url: `/ims/Uapi/smsCode/${mobile}`,
    method: 'GET',
    params
  })
}

export function smsCode2(data) {
  return request({
    url: `/sms/smsCode`,
    method: 'POST',
    data
  })
}

export function userRegister(data) {
  return request({
    url: `/ims/Uapi/user/register`,
    method: "POST",
    data,
  });
}

export function authKey(data) {
  return request({
    url: `/ims/Uapi/auth/key`,
    method: 'POST',
    data
  })
}

// 身份信息下拉列表
export function identitySimple(params) {
  return request({
    url: `/ims/Uapi/identity/simple`,
    method: 'GET',
    params
  })
}

export function forgetPassword(data) {
  return request({
    url: `/ims/Uapi/user/forgetPassword`,
    method: "POST",
    data,
  });
}

export function memberInfo() {
  return request({
    url: `/ims/Uapi/user/info`,
    method: 'GET',
  })
}

export function switchMember(memberCode) {
  return request({
    url: `/ims/Uapi/switchMember/${memberCode}`,
    method: "POST"
  });
}


export function switchMember3(data) {
  return request({
    url: `/ims/Uapi/switchMemberIdentity`,
    method: "POST",
    data
  });
}

export function switchMember2(data) {
  return request({
    url: `/ims/Uapi/switchMember`,
    method: "POST",
    data
  });
}

export function priceData(contractId, params) {
  return request({
    url: `/price/index/${contractId}`,
    method: 'GET',
    params,
    baseURL: process.env.VUE_APP_PRICE_API
  })
}

export function priceGuidData(contractId) {
  return request({
    url: `/price/guid/${contractId}`,
    method: 'GET',
    baseURL: process.env.VUE_APP_PRICE_API
  })
}

export function priceGuidOutData(contractId) {
  return request({
    url: `/price/guid/outside/${contractId}`,
    method: 'GET',
    baseURL: process.env.VUE_APP_PRICE_API
  })
}

export function leaveWord(data) {
  return request({
    url: `/ims/LeaveWord`,
    method: "POST",
    data
  });
}

export function countriesData(params) {
  return request({
    url: `/upms/dict/countries/page`,
    method: 'GET',
    params
  })
}

export function citiesData(params) {
  return request({
    url: `/upms/dict/cities/page`,
    method: 'GET',
    params
  })
}

export function memberCompanyApply(data) {
  return request({
    url: `/ims/Uapi/member/company/apply`,
    method: "POST",
    data
  });
}

export function memberCompanyInviteBase(data) {
  return request({
    url: `/ims/Uapi/member/invite/apply`,
    method: "POST",
    data
  });
}

export function memberCompanyInviteExtra(data, applyId) {
  return request({
    url: `/ims/Uapi/member/invite/supplement/${applyId}`,
    method: "POST",
    data
  });
}

export function companyApplyStatus(params) {
  return request({
    url: '/upms/member/company/companyApplyStatus',
    method: 'get',
    params
  })
}

export function companyApplyDetail(id, params) {
  return request({
    url: `/ims/Uapi/member/company/applyRecord/${id}/detail`,
    method: 'get',
    params
  })
}
export function memberApllyPage(params) {
  return request({
    url: `/ims/Uapi/member/apply/page`,
    method: 'GET',
    params
  })
}

export function memberPage(userId) {
  return request({
    url: `/ims/Uapi/userMemberInfo/list/${userId}`,
    method: 'GET'
  })
}



// 首页商品列表

export function hotGoodsList(channelId, params) {
  return request({
    url: `/ims/ExternalSysApi/hotGoods/${channelId}`,
    method: 'get',
    params
  })
}

export function clientManagers(params) {
  return request({
    url: `/upms/user/inner/clientManagers`,
    method: 'GET',
    params
  })
}

export function attachTempleteList(params) {
  return request({
    url: `/upms/member/attachTemplete/list`,
    method: 'GET',
    params
  })
}




